/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { R100 } from '@atlaskit/theme/colors';
import { badge } from './styles';
export var ColoredAvatarItem = function ColoredAvatarItem(props) {
  var _props$api;
  var color = (_props$api = props.api) === null || _props$api === void 0 || (_props$api = _props$api.collabEdit) === null || _props$api === void 0 || (_props$api = _props$api.actions) === null || _props$api === void 0 ? void 0 : _props$api.getAvatarColor(props.sessionId).color;
  var avatar = props.name.substr(0, 1).toUpperCase();
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: badge(color || R100),
      "data-testid": "editor-collab-badge"
    }, avatar)
  );
};